<template>
  <div>
    <v-card outlined>
      <v-card-title class="py-1">
        <v-row class="caption">
          <v-col cols="6">
            Route ID
          </v-col>
          <!-- <v-col cols="6">Dropoffs</v-col> -->
          <v-col
            class="text-center"
            cols="6"
          >
            Status
          </v-col>
        </v-row>
      </v-card-title>

      <v-divider />

      <v-text-field
        v-model="filters.search"
        dense
        outlined
        hide-details
        label="Search by Route ID"
        prepend-inner-icon="mdi-magnify"
        class="ma-3"
      />

      <v-divider />

      <v-card-text class="pa-0">
        <div v-if="isLoading">
          <v-progress-linear indeterminate />
        </div>

        <template v-if="routes.length">
          <v-row
            v-for="(route, index) in filteredRoutes"
            :key="route.id"
            align="center"
            class="px-0 mx-0 route-row"
            :class="{
              'blue-grey lighten-5': selectedRouteId === route.id,
            }
            "
            @click="onRouteClick(route)"
          >
            <v-col
              class="px-3"
              cols="6"
            >
              {{ route.routeId || "N/A" }}

              <v-tooltip
                v-if="!route.isFeasible"
                top
              >
                <template v-slot:activator="{ on }">
                  <v-icon
                    :disabled="isLoading"
                    small
                    class="mx-1"
                    color="grey"
                    v-on="on"
                    @click="displayConfirmation(route)"
                    v-text="'mdi-refresh'"
                  />
                </template>
                <span>Move to backlog</span>
              </v-tooltip>
            </v-col>
            <!-- <v-col cols="6">{{ route.path.length || "N/A" }}</v-col> -->
            <v-col
              class="text-center px-3"
              cols="6"
            >
              <v-chip
                v-if="!route.isFeasible"
                dark
                label
                color="red"
              >
                Not Feasible
              </v-chip>
              <v-chip
                v-else
                dark
                label
                :color="getStatusColor(route.status)"
              >
                {{ route.status || "N/A" }}
              </v-chip>
            </v-col>
            <v-col
              v-if="index !== routes.length - 1"
              class="pa-0"
              cols="12"
            >
              <v-divider />
            </v-col>
          </v-row>
        </template>

        <div
          v-else-if="isLoading"
          class="pa-5"
        >
          Loading Routes...
        </div>

        <div
          v-else
          class="pa-5 text-center grey--text"
        >
          <v-icon
            color="grey"
            size="50"
          >
            mdi-text-box-search-outline
          </v-icon>
          <div class="subtitle-2 my-1">
            No Routes Available
          </div>
        </div>
      </v-card-text>
    </v-card>

    <confirmation-dialog
      v-if="confirmationDialog.isOpen"
      :color="confirmationDialog.color"
      :subtitle="confirmationDialog.subtitle"
      @close="resetConfirmationDialog"
      @accept="confirmationDialog.callback"
    />
  </div>
</template>

<script>
import ConfirmationDialog from '@/components/commons/ConfirmationDialog.vue';

function defaultConfirmationDialog() {
  return {
    subtitle: '',
    isOpen: false,
    color: 'primary',
    callback: () => {},
  };
}

export default {
  components: { ConfirmationDialog },
  props: {
    selectedRouteId: {
      type: String,
      default: '',
    },
    routes: {
      type: Array,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      filters: {
        search: '',
      },
      confirmationDialog: defaultConfirmationDialog(),
    };
  },
  computed: {
    filteredRoutes() {
      return this.routes.filter((route) => route.routeId.includes(this.filters.search))
        .sort((a, b) => b.total_pallet_cost - a.total_pallet_cost);
    },
  },
  methods: {
    displayConfirmation(route) {
      const subtitle = 'Are you sure you want to move the route to backlog?';

      this.confirmationDialog = {
        ...this.confirmationDialog,
        subtitle,
        isOpen: true,
        callback: () => {
          this.$emit('move-to-backlog', [route.id]);
          this.resetConfirmationDialog();
        },
      };
    },
    resetConfirmationDialog() {
      this.confirmationDialog = defaultConfirmationDialog();
    },
    onRouteClick(route) {
      this.$emit('select-route', route);
    },
    getStatusColor(status) {
      const colorMapper = {
        Accepted: 'primary',
        Completed: 'green',
      };

      return colorMapper[status];
    },
  },
};
</script>

<style scoped>
  .cursor-not-allowed {
    cursor: not-allowed;
  }

  .route-row {
    cursor: pointer;
  }

  .route-row:hover {
    transition: 0.5s;
    background: #f5f5f5;
  }
</style>
